import React from 'react';
import ReportContainer from '../../../components/ReportComponent/ReportContainer';
import { Container } from '@mui/material';
import styleGlobal from '../../../Global.module.css';
import ErrorSpecific from 'ErrorSpecific';

export default function ReportMensal() {
  return (
    <header className={styleGlobal.headerRelatorios}>
      <ReportContainer>
        <Container
          style={{
            paddingInline: '2rem',
          }}
        >
          <ErrorSpecific />
        </Container>
      </ReportContainer>
    </header>
  );
}
